angular
  .module('surfsightApp.controllers')
  .controller('EdgeGenerateOTUController', [
    '$scope',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    'dataFromCaller',
    'edgeFactory',
    function (
      $scope,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      dataFromCaller,
      edgeFactory
    ) {
      $scope.edge_id = dataFromCaller.edge_id
      var edge = edgeFactory.findItemById($scope.edge_id).item
      $scope.broadcast = dataFromCaller.broadcast.number
      $scope.broadcastName = dataFromCaller.broadcast.name
      $scope.otu_request = {
        otu_type: 'SINGLE',
        edge_id: edge.id,
        edge_name: edge.name,
        uri: edge.uri,
        uri_type: edge.uri_type,
        organizationId: $localStorage.userDetails.organizationId,
        broadcast: $scope.broadcast,
        broadcastName: $scope.broadcastName,
        send_only: false,
        contribution: false,
        automatic_contribution: false
      }
      $scope.toggle_contribution = function () {
        $scope.otu_request.send_only = false
        $scope.otu_request.automatic_contribution = false
      }
      $scope.toggle_send_only = function () {
        $scope.otu_request.contribution = false
        $scope.otu_request.automatic_contribution = false
      }
      $scope.timeBomb_picker_options = {
        position: 'bottom left',
        animation: {
          open: {
            effects: 'slideIn:up'
          }
        }
      }
      $scope.generateOtu = function () {
        var max_entries = $scope.otu_request.max_entries
        var time_bomb = $scope.otu_request.time_bomb
        if (time_bomb) {
          if (
            new Date(time_bomb).toString() == 'Invalid Date' ||
            !new Date(time_bomb)
          ) {
            var toast = $mdToast
              .simple()
              .textContent('Please enter valid date and time.')
              .action('ok')
              .position('bottom')
              .actionKey('F1')
              .hideDelay(5000)
              .parent('#generate-otu-container')

            $mdToast
              .show(toast)
              .then(function (response) {
                if (response == 'ok') {
                  // alert('You clicked the \'UNDO\' action.');
                }
              })
              .catch(() => {})
            return false
          }
        }
        if (!max_entries || max_entries == 0 || isNaN(max_entries)) {
          var toast = $mdToast
            .simple()
            .textContent('Please enter maximum entries for OTU.')
            .action('ok')
            .position('bottom')
            .actionKey('F1')
            .hideDelay(5000)
            .parent('#generate-otu-container')

          $mdToast
            .show(toast)
            .then(function (response) {
              if (response == 'ok') {
                // alert('You clicked the \'UNDO\' action.');
              }
            })
            .catch(() => {})
          return false
        }
        $scope.otu_request.max_entries = parseInt(max_entries)
        var request_json = {
          method: 'POST',
          url: OTU_BASEURL + '/create',
          data: $scope.otu_request
        }
        // console.log(request_json);
        $http(request_json).then(
          function (response) {
            // console.log(response);
            if (response.data.status.code == 0) {
              $mdDialog.hide(response)
            } else {
              var toast = $mdToast
                .simple()
                .textContent(response.data.status.error)
                .action('ok')
                .position('bottom')
                .actionKey('F1')
                .hideDelay(3000)
                .parent('#generate-otu-container')

              $mdToast
                .show(toast)
                .then(function (response) {
                  if (response == 'ok') {
                    // alert('You clicked the \'UNDO\' action.');
                  }
                })
                .catch(() => {})
            }
          },
          function (response) {
            handleServerError(response)
            $scope.showMessageToast(response.data.status.error)
          }
        )
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
      function handleServerError (response) {
        $scope.$emit('handleServerError', response)
      }
    }
  ])
